import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cs_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("cs_token");
        localStorage.removeItem("cs_user");
      })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
    return data.user;
  }

  async function register(payload) {
    const { data } = await api.post("/auth/register", payload);
    persist(data);
    return data.user;
  }

  async function loginWithGoogleCredential(credential, referralCode) {
    const { data } = await api.post("/auth/google/session", { credential, referral_code: referralCode || null });
    persist(data);
    return data.user;
  }

  function persist(data) {
    localStorage.setItem("cs_token", data.access_token);
    localStorage.setItem("cs_user", JSON.stringify(data.user));
    setUser(data.user);
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("cs_token");
    localStorage.removeItem("cs_user");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, loading, loginWithGoogleCredential }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
